import fetch from '@/axios/promise';
import  {DIC_URL,PROJ_URL,INNER_USER,PROV_CITY_URL} from  '@/config/constant';

// 获取字典表编码获取字典数据
// ******** 参数名： cateCode ，类别编码
export function getDicData(query) {
  return invoke(query,'/item/list/cateCode','GET',DIC_URL);
}

// 根据人员编码获取项目数据 ，参数 {personCode:''}
export function getPersonProjectData(query) {
  return invoke(query,'/getPersonProjectData','POST',PROJ_URL);
}

// 获取内容人员数据 条件 condition: json字符串，null所有
export function getInnerUserData(query) {
  return invoke(query,'/list/info','POST',INNER_USER);
}

// 获取省份城市级联数据
export function getProvCityCascadeList(query){
  return invoke(query,'/getProvCityCascadeList','POST',PROV_CITY_URL);
}

// 调用
function invoke(query,url,method,head){
  return fetch({
    url: head+url,
    method: method,
    params: query
  });
}


// WEBPACK FOOTER //
// ./src/api/common/dic.js